/**
 * blog/posts.js — central registry of blog posts.
 *
 * iter100 — Blog structure scaffolding (P9). Articles are added one by
 * one as Markdown-ish strings here so the entire blog is statically
 * indexable by Google + ChatGPT crawlers (no API/DB roundtrip). Each
 * post becomes an Article schema.org JSON-LD record on `BlogPost.jsx`.
 *
 * Add new posts by appending to BLOG_POSTS. Fields:
 *   slug          - URL slug (lowercased, dash-separated)
 *   title         - <title> + H1
 *   description   - meta description (≤160 chars)
 *   tag           - high-level category label
 *   author        - byline (defaults to "NoFee Team")
 *   datePublished - ISO 8601 string
 *   readTimeMin   - rough estimate, surfaced in card
 *   cover         - hero image path (absolute or /brand/... in /public)
 *   body          - HTML string. Use semantic <h2>, <p>, <ul>, <strong>.
 */

export const BLOG_POSTS = [
  // First articles will be added on a follow-up PR per owner request
  // (Feb 2026). The structure below is fully wired — including SEO,
  // Article JSON-LD, sitemap entries, and per-post canonical URLs — so
  // dropping new objects into this array is the only action needed to
  // ship a new piece of content.
];

export const getPostBySlug = (slug) =>
  BLOG_POSTS.find((p) => p.slug === slug) || null;

export const ALL_POST_SLUGS = () => BLOG_POSTS.map((p) => p.slug);
